import { Card, Icon, Tag, Text } from '@pm/ui';
import { useTranslation } from 'react-i18next';
import { IconListItem } from '../../../components/IconListItem/IconListItem';
import { AdditionalConditionCards } from './AdditionalConditionCards';
import { type AdditionalConditionItem } from './types';

export { ADDITIONAL_CONDITION_STATES } from './types';
export type {
  AdditionalConditionCardState,
  AdditionalConditionItem,
  AdditionalConditionName,
} from './types';

export type AdditionalConditionsListProps = {
  conditions: AdditionalConditionItem[];
};

const checkIcon = (
  <Icon name="check_circle" color="text-content-positive" size="large" />
);

export const AdditionalConditionsContent = ({
  conditions,
}: AdditionalConditionsListProps) => {
  const { t } = useTranslation('treatments', {
    keyPrefix: 'AdditionalTreatmentsList',
  });

  return (
    <div className="flex flex-col space-y-s">
      <div className="flex flex-wrap items-center gap-x-xs gap-y-xxs">
        <Text size="headingS">{t('Title')}</Text>
        <Tag intent="info" size="small">
          {t('NewBadge')}
        </Tag>
      </div>
      <div>
        <Text as="span" size="bodyL">
          {t('IntroText')}
        </Text>
      </div>

      <div className="flex flex-row gap-x-xs sm:gap-x-l pb-xxs sm:pb-s">
        <IconListItem
          icon={checkIcon}
          textContent={t('FreeClinicalAssessment')}
          textSize="label"
        />
        <IconListItem
          icon={checkIcon}
          textContent={t('DeliveryIncluded')}
          textSize="label"
        />
      </div>

      <div className="mt-m">
        <AdditionalConditionCards conditions={conditions} />
      </div>
    </div>
  );
};

export const AdditionalConditionsListCard = ({
  conditions,
}: AdditionalConditionsListProps) => {
  if (conditions.length === 0) {
    return null;
  }

  return (
    <Card size="large" state="surfaceStrong">
      <AdditionalConditionsContent conditions={conditions} />
    </Card>
  );
};
